import { DefaultPageState } from "../../../../common/models/StoreDefaultModel";

export type UserItemData = {};

export const initialUserPageState: any = {
  page: 1,
  itemsPerPage: 10,
  isShow: 1,
  // pagination: true,

  // order: { dataKey: "id", order: "desc" },
};
